import { getSchema as getSchema1, uiSchema as uiSchema1, } from "./schema.signUp.1";
// eslint-disable-next-line import/no-default-export
export default (function (extraData) { return [
    {
        schema: getSchema1(extraData),
        uiSchema: uiSchema1(),
    },
]; });
